import {send} from 'ajax';

const name = document.getElementById('name');
const _location = document.getElementById('location');
const age = document.getElementById('age');
const kid_reason_dropdown = document.getElementById('kid_reasons');
const adult_reason_dropdown = document.getElementById('adult_reasons');
const email = document.getElementById('email');
const agree = document.getElementById('agree');
const postcard_video = document.getElementById('watch_video');
const replay_video = document.getElementById('replay_video');
const watcher_overlay = document.getElementById('watcher_overlay');

var first_time = true;

if (watcher_overlay) {
  watcher_overlay.addEventListener('click', (event) => {
    watcher_overlay.classList.add('hidden');
    document.getElementById('video_overlay').classList.remove('on_display');
    document.getElementById('abs_pointer').classList = 'hidden';
    document.getElementById('abs_pointer_share').classList = 'hidden';
  });
}

if (postcard_video) {
  /*window.onscroll = function () {
    setTimeout( function(){
      watcher_overlay.classList.add('hidden');
      document.getElementById('video_overlay').classList.remove('on_display');
      document.getElementById('abs_pointer').classList = 'hidden'
      document.getElementById('abs_pointer_share').classList = 'hidden';
    }, 300);
  }*/
  if (document.getElementById('i_am_viewer')) {
    postcard_video.addEventListener('ended', (event) => {
    console.log('ended');
    try {
      document.webkitExitFullscreen();
    }
    catch(err) {}
    try {
      document.mozCancelFullscreen();
    }
    catch(err) {}
    try {
      document.exitCancelFullscreen();
    }
    catch(err) {}

      setTimeout( function() {
        var ov = document.getElementById('overlay_video_div');
        //ov.style.width = postcard_video.offsetWidth + 'px';
        //ov.style.height = postcard_video.offsetHeight  + 'px';
        ov.classList.remove('hidden');
        }, 200);
    if (first_time) { 
       setTimeout( function() {
        document.getElementById('watcher_overlay').classList.remove('hidden');
        document.getElementById('video_overlay').classList.add('on_display');
        document.getElementById('abs_pointer').classList.remove('hidden');
        }, 400);
       first_time = false;
     }
    });
  }
  else {
    postcard_video.addEventListener('ended', (event) => {
    console.log('ended');
    try {
      document.webkitExitFullscreen();
    }
    catch(err) {}
    try {
      document.mozCancelFullscreen();
    }
    catch(err) {}
    try {
      document.exitCancelFullscreen();
    }
    catch(err) {}

    if (first_time) { 
       setTimeout( function() {
        window.location.hash = '#watch_video';
        document.getElementById('watcher_overlay').classList.remove('hidden');
        document.getElementById('abs_pointer_share').classList.remove('hidden');
        }, 200);
       first_time = false;
     }
    });
  }
}

// keep background sizing in line
adjust_background();
window.addEventListener('resize', adjust_background, true);

let create_video_button = document.getElementById('create_video_button');
if (create_video_button) {
  create_video_button.addEventListener('click',function(e) { e.preventDefault(); start_video_process();});
}

const age_select = document.getElementById('age');
if (age_select) {
  age_select.addEventListener('change', function(e) { updateReasons( this.value) });
}

if (kid_reason_dropdown) {
  kid_reason_dropdown.addEventListener('change', function(e) { updateListType() });
  adult_reason_dropdown.addEventListener('change', function(e) { updateListType() });
}

if (_location) {
  _location.addEventListener('change', function(e) { _location.classList=''; });
}

if (name) {
  name.addEventListener('change', function(e) { name.classList=''; });
}
 
if (email) {
  email.addEventListener('change', function(e) { email.classList=''; });
}

if (agree) {
  agree.addEventListener('change', function(e) { agree.classList='video'; });
}

if (postcard_video) {
  postcard_video.addEventListener('play', (event) => {
    console.log('play triggered');
    setTimeout(function(){postcard_video.classList = 'after_play';}, 500);
  });
}

function updateListType() {

  kid_reason_dropdown.classList.remove('error');
  adult_reason_dropdown.classList.remove('error');

  var reason_tag;

  if (isKid()) {
    reason_tag = kid_reason_dropdown.value.split('|')[1];
  }
  else {
    reason_tag = adult_reason_dropdown.value.split('|')[1];
  }
 
  if ((reason_tag||'').includes('nice')) {
    document.getElementById('list_type').value = 'good';
    document.getElementById('list_type_div').classList = '';
    adjust_background();
  }
  else {
    if ((reason_tag||'').includes('naughty')) {
      document.getElementById('list_type').value = 'naughty';
      document.getElementById('list_type_div').classList = '';
      adjust_background();
    }
    else {
      // default to good if no selection
      document.getElementById('list_type').value = 'good';
      document.getElementById('list_type_div').classList = 'hidden';
      adjust_background();
    }
  }
   
}

function isKid(){
  return age_select.value == 'kid';
}  

function updateReasons(age) {
  if (age == 'kid') {
    kid_reason_dropdown.classList = '';
    adult_reason_dropdown.classList = 'hidden';
  }
  else {
    kid_reason_dropdown.classList = 'hidden';
    adult_reason_dropdown.classList = '';
  }
  updateListType();
  
}

function check_values(){
  let pass = true;

  if (name.value == '') {
    name.classList.add('error');
    pass = false;
  }
  else {
    name.classList.remove('error');
  }

  let show_email = document.getElementById('show_email');
  if (show_email && show_email.innerHTML == 'yes') { 
    if (email.value == '') {
      email.classList.add('error');
      pass = false;
    }
    else {
      email.classList.remove('error');
    }
  }

  if (!agree.checked) {
    agree.classList.add('error');
    pass = false;
  }
  else {
    agree.classList.remove('error');
  }

  if (_location.value == '') {
    _location.classList.add('error');
    pass = false;
  }
  else {
    _location.classList.remove('error');
  }

  if (age.value == 'kid' && kid_reason_dropdown.value == '') {
    kid_reason_dropdown.classList.add('error');
    pass = false;
  }
  else {
    kid_reason_dropdown.classList.remove('error');
  }
  
  if (age.value == 'adult' && adult_reason_dropdown.value == '') {
    adult_reason_dropdown.classList.add('error');
    pass = false;
  }
  else {
    adult_reason_dropdown.classList.remove('error');
  }

  return pass;
}

function start_video_process() {
  if (check_values() ) {
    submit_video();
    let progress = document.getElementById('progress');
    document.getElementById('video_loading').classList.remove('hidden');
    var timer = 5000;
    setTimeout( function(){progress.innerHTML = "He's getting out his book of naughty or nice"; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = 'The elves are setting up his video camera'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = 'Mrs. Claus stopped by to give him a cookie'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = 'Your video will be ready soon!'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = 'It will be here faster than the 12 Days of Christmas!'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '12 Drummers Drumming'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '11 Pipers Piping'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '10 Lords a Leaping'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '9 Ladies Dancing'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '8 Maids a Milking'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '7 Swans a Swimming'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '6 Geese a Laying'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '5 Golden Rings!'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '4 Calling Birds'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '3 French Hens'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = '2 Turtle Doves'; }, timer);
    timer = timer + 5000;
    setTimeout( function(){progress.innerHTML = 'And a Partridge in a Pear Tree!'; }, timer);
  }
}

var checkVideo;

async function submit_video() {
  // disable page and start loading process
  // trigger creation of the video
  let name_text = document.getElementById('name');
  let location_dropdown = document.getElementById('location');
  let age = age_select.value; 
  
  let base_path = 's3://tfsphoto/uploads/video_clip/video/';
  let name = name_text.value;
  let location_video = base_path + location_dropdown.value;
  let kid_reason_video = base_path + kid_reason_dropdown.value.split('|')[0];
  let adult_reason_video = base_path + adult_reason_dropdown.value.split('|')[0];
  let kid_reason = kid_reason_dropdown.options[kid_reason_dropdown.selectedIndex].text;
  let adult_reason = adult_reason_dropdown.options[adult_reason_dropdown.selectedIndex].text;
  let reason = age == 'kid' ? kid_reason : adult_reason;
  let reason_video = age == 'kid' ? kid_reason_video : adult_reason_video;
  let list = document.getElementById('list_type').value;
  let this_email = email.value;
  

  const data = await send("POST", "/api/process_postcard_video",`name=${name}&location_video=${location_video}&reason_video=${reason_video}&reason=${reason}&age=${age}&list=${list}&email=${this_email}`);

  let this_sub = document.getElementById('sub');
  let this_sub_string = this_sub ? this_sub.innerHTML : ''
  
  if (!data) { 
    console.log('Error!  Need to handle this!');
  }
  else {
    if (data.ready == 'yes') {
      Turbolinks.visit('/santa-video/watch_video?v=' + data.id_token + '&sub=' + this_sub_string);
    }
    else {
      checkVideo = setInterval(function(){checkForVideo(data.id_token)}, 5000);
    }
  }
}

async function checkForVideo(id_token){
  let this_sub = document.getElementById('sub');
  let this_sub_string = this_sub ? this_sub.innerHTML : ''
  const data = await send("GET", "/api/video_ready?id_token=" + id_token + "&sub=" + this_sub_string);
  if (data && data != '') {
    console.log('done!');
    clearInterval(checkVideo);
    Turbolinks.visit('/santa-video/watch_video?v=' + id_token + '&sub=' + this_sub_string);
  }
  else {
    console.log('data is: ' + data);
  }
}

function adjust_background() {
  let video_background = document.getElementById('video_background_one');
  if (video_background) {
    let video_box = document.getElementById('video_box');
    video_background.style.height = (video_box.offsetHeight + 30) + 'px';
    let width_diff = video_background.offsetWidth - video_box.offsetWidth;
    if (width_diff > 0) {
      //video_box.style.marginLeft = (width_diff/2)+ 'px';
    }
  }
  
  let video_watch_div = document.getElementById('video_box_watch_video');
  if (video_watch_div) {
    console.log('adjusting width to ' + video_watch_div.offsetWidth );
    document.getElementById('video_box_inner_watch').style.width = (video_watch_div.offsetWidth - 30) + 'px';
  }
}

if (replay_video) {
  replay_video.addEventListener('click', (event) => {
    var ov = document.getElementById('overlay_video_div');
    ov.classList.add('hidden');
    postcard_video.play();
  });
}
  
/* Video sharing */
var fbButton = document.getElementById('clickFBButton');
if (fbButton) {
  fbButton.addEventListener('click', (event) => {
  recordShare();
  document.querySelector('.ba-commoncss-icon-facebook').click();
  });
}

var twButton = document.getElementById('clickTWButton');
if (twButton) {
  twButton.addEventListener('click', (event) => {
  document.querySelector('.ba-commoncss-icon-twitter').click();
  });
}

var cpButton = document.getElementById('copyURL');
if (cpButton) {
  cpButton.addEventListener('click', (event) => {
  copy_to_clipboard();   
  });
}

function copy_to_clipboard() {
  /* Get the text field */
  var copyText = document.getElementById("url_public_id");
  var copyDiv = document.getElementById("dontshowme");
  copyDiv.classList.remove('hidden');

  /* Select the text field */
  copyText.select();
  copyText.setSelectionRange(0, 99999); /*For mobile devices*/

  /* Copy the text inside the text field */
  document.execCommand("copy");

  copyDiv.classList.add('hidden');
  /* Alert the copied text */
  alert("Copied!");
}


export async function recordShare(){
  try {
    let link_url = "/santa/hit?path=fb_share"; 
    const hitr = await send("GET", link_url);
  }
  catch (err) {
    console.log('hit page testing err: ' + err);
  }
}

